import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { ServerSideDataLoader, PaginationInfo } from "uicomponents";
import  { DollarPriceManipulationView } from "./dollarPriceManipulation-view"
import { CarBrandSelectorViewModel } from "src/Warehouse/carBrandManipulation/carBrandManipulation-viewModel";
import { DirhamPriceManipulationViewModel } from "../dirhamPriceManipulation/dirhamPriceManipulation-viewModel";

export class DollarPriceManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'قیمت دلار';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.dollarPrice = ObservableArray.create<dollarPrice>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),15);
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new DollarPriceManipulationView();
    }
    public getTypeId(): string {
        return "VM-8C5E6F40-CFCB-4685-8A61-6E816EF10C32"
    }

    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set dollarPrice(v: ObservableArray<dollarPrice>) { this._dollarPrice = v; } public get dollarPrice(): ObservableArray<dollarPrice> { return this._dollarPrice;} private _dollarPrice: ObservableArray<dollarPrice>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    refresh(){
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            if(filteringInformation.OrderInfo.length == 0)
            {
                let sort = {
                    fieldName:'From',
                    order:'DESC',
                    type:'date'
                };
                filteringInformation.OrderInfo = [sort];
            }
            let result = await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/GetAllDollarPrice',{
                FilteringInformation:filteringInformation
            });
            this.dollarPrice.update(...result.DollarPrice.map(q=>{
                let r = new dollarPrice(this);
                r.id = q.Id;
                r.price = q.Price;
                r.carModelId = q.CarModelId;
                r.carModelName = q.CarModelName;
                r.from = moment.utc(q.From);
                r.until = q.Until==null? null : moment.utc(q.Until);
                r.canInactive = q.Until==null;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    async requestDollarPriceCreation(){
        let editor = new dollarPriceEditor(this,new InsertServerUpdater());
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }

    async dirhamPrice(){
        let editor = new DirhamPriceManipulationViewModel(this);
        let resultCode = await this.showPopup(editor);
        
    }

    async accept(id:any){
        try {
            this.isLoading = true;
            await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/DollarPriceInvalidator',{
                Id:id
            });
            await this.messageBoxConfirmSuccess('قیمت دلار غیر فعال شد','عملیات موفق');
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
            this.loader.refresh();
        }
    }
}
export class dollarPrice extends ViewModel{
    
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:DollarPriceManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
        
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set price(v: string) { this._price = v; } public get price(): string { return this._price;} private _price: string;
    public set carModelId(v: string) { this._carModelId = v; } public get carModelId(): string { return this._carModelId;} private _carModelId: string;
    public set carModelName(v: string) { this._carModelName = v; } public get carModelName(): string { return this._carModelName;} private _carModelName: string;
    public set until(v: moment.Moment) { this._until = v; } public get until(): moment.Moment { return this._until;} private _until: moment.Moment;
    public set from(v: moment.Moment) { this._from = v; } public get from(): moment.Moment { return this._from;} private _from: moment.Moment;
    public set canInactive(v: boolean) { this._canInactive = v; } public get canInactive(): boolean { return this._canInactive;} private _canInactive: boolean;
        
    private _typedParent:DollarPriceManipulationViewModel;

    async inactiveDollarPrice():Promise<void>{
        if(this.canInactive) {
            let result:string; 
            result = await this.messageBoxWarningYesNo('آیا مطمئنید؟','غیرفعال کردن قیمت دلار');
            if(result=='yes'){
                this._typedParent.accept(this.id);
            }
        }
    }

    setModel(id: string, name: string) {
        this.carModelId = id;
        this.carModelName = name;
    }

    getModelId() {
        return this.carModelId;
    }    

}

interface IServerUpdater{
    execute(dollarPrice:dollarPrice):Promise<void>;
    getSuccessMessage():string;
}

class InsertServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'قیمت دلار با موفقیت ثبت شد.';
    }
    async execute(dollarPrice: dollarPrice): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/CreateDollarPrice',{
            CarModelId:dollarPrice.getModelId(),
            Price:dollarPrice.price
        });
        if(result.IsSuccessful==false){
            throw "new Error";
        }
    }
}

export class dollarPriceEditor extends dollarPrice implements IPopup{
    public getTypeId(): string {return 'dollar';}
    public GetDefaultView(): View<ViewModel> {return null;}

    constructor(parent:DollarPriceManipulationViewModel,serverUpdater:IServerUpdater) {
        super(parent);
        this._serverUpdater = serverUpdater;
        this.carModelSelector = new CarBrandSelectorViewModel(this);
    }
    closePopup(resultCode: string = null) {
    }
    
    private _serverUpdater:IServerUpdater;
    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set carModelSelector(v: CarBrandSelectorViewModel) { this._carModelSelector = v; } public get carModelSelector(): CarBrandSelectorViewModel { return this._carModelSelector;} private _carModelSelector: CarBrandSelectorViewModel;
    
    verify():string[]{
        let result :string[] =[];
        if(stringIsNullOrEmpty(this.price)){
            result.push(' قیمت مشخص نشده است.')
        } 
        if(stringIsNullOrEmpty(this.getModelId())){
            result.push('نوع خودرو مشخص نشده است.')
        }
        return result;
    }
  
    setModel(id: string, name: string) {
        this.carModelSelector.selectById(id);
    }

    getModelId() {
        return this.carModelSelector.selectedItem?.id;
    }
    
    async save(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت قیمت دلار');
                return;
            }
            this.isLoading = true;
            await this._serverUpdater.execute(this);
            await this.messageBoxConfirmSuccess(this._serverUpdater.getSuccessMessage(),'عملیات موفق');
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    back(){
        this.closePopup();
    }

}